<template>
  <v-dialog
    :value="value"
    max-width="460"
    persistent
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title class="text-h6">
        Close batch?
      </v-card-title>
      <v-card-text>
        Once closed, statement records can't be linked or unlinked, and matching
        can't be re-run. This batch will move to read-only.
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-spacer />
        <v-btn
          text
          :disabled="submitting"
          @click="$emit('input', false)"
        >
          Cancel
        </v-btn>
        <v-btn
          color="error"
          depressed
          :loading="submitting"
          @click="$emit('confirm')"
        >
          Close batch
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'BulkCloseConfirmDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
